import React from "react";
import { getGroupsData } from '../../assets/data';

export default function CopyLessonModal({
  showCopyModal, setShowCopyModal,
  lessonToCopy,
  copyTargetStudent, setCopyTargetStudent,
  copyModalGroups,
  copyDate, setCopyDate,
  copyLessonSubmitting,
  confirmCopyLesson,
}) {
  if (!showCopyModal) return null;

  return (
    <div className="custom-modal-overlay">
      <div className="custom-modal copy-lesson-modal">
        <div className="custom-modal-header">
          <h3>Copy Lesson</h3>
          <button className="custom-modal-close" onClick={() => setShowCopyModal(false)}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>
        </div>
        <div className="custom-modal-body">
          <p>Copy lesson "{lessonToCopy?.title}" to another group:</p>

          <div className="copy-form-group copy-form-group-select">
            <label>Group</label>
            <select
              value={copyTargetStudent}
              onChange={(e) => setCopyTargetStudent(e.target.value)}
              className="copy-select"
            >
              <option value="">Select a group...</option>
              {(() => {
                const local = getGroupsData();
                const merged = { ...local, ...(copyModalGroups || {}) };
                return Object.keys(merged)
                  .map(id => (
                    <option key={id} value={id}>
                      {merged[id]?.name || id}
                    </option>
                  ));
              })()}
            </select>
          </div>

          <div className="copy-form-group copy-form-group-date">
            <label>Date</label>
            <input
              type="date"
              value={copyDate}
              onChange={(e) => setCopyDate(e.target.value)}
              className="copy-input copy-input-date"
            />
          </div>
        </div>
        <div className="custom-modal-footer">
          <button className="custom-modal-btn cancel-btn" onClick={() => setShowCopyModal(false)} disabled={copyLessonSubmitting}>
            Cancel
          </button>
          <button className="custom-modal-btn confirm-btn" onClick={confirmCopyLesson} disabled={copyLessonSubmitting}>
            {copyLessonSubmitting ? (
              <>
                <span className="copy-lesson-btn-spinner" aria-hidden />
                Copying…
              </>
            ) : (
              'Copy Lesson'
            )}
          </button>
        </div>
      </div>
    </div>
  );
}
